import React from 'react';
import { isNullOrEmptyString } from '../services/UtilityService';

const ErrorAlertMessageBody = ({ errorMessage }) => {
    if (isNullOrEmptyString(errorMessage)) return null;
    return (
        <div>
            <div style={{ textAlign: 'center', color: 'red', fontSize: '1.5rem' }}>
                <i className="bi bi-exclamation-triangle-fill"></i>
            </div>
            <div style={{textAlign: 'center'}}>
                {errorMessage}
            </div>
        </div>
    );
};

export default ErrorAlertMessageBody;
